import { DateTime } from 'luxon';
import {
  Activity,
  ActivityState,
  ResponseDateTime,
  Location,
} from 'domains/ActivityForm/openapi-client/models';
import { SubLocation } from '../types/sublocation';

export function getFormattedTime(dateTime: ResponseDateTime) {
  if (dateTime.isTbd) {
    return 'TBD';
  }
  const formattedTime = DateTime.fromFormat(dateTime.time, 'HH:mm').toFormat(
    'h:mma'
  );
  return formattedTime.toLowerCase().replace(':00', '');
}

export function isActivityExternal(activity: Activity) {
  return !!activity.externalProviderId || !!activity.externalProviderName;
}

export function formatDate(dateStr: string): string {
  const inputFormat = 'yyyy-MM-dd';
  const outputFormat = 'cccc, LLLL d, yyyy';
  const date = DateTime.fromFormat(dateStr, inputFormat);
  return date.toFormat(outputFormat);
}

export function isAllDayActivity(activity: Activity): boolean {
  return (
    !!activity.allDay &&
    activity.start !== undefined &&
    activity.end !== undefined &&
    activity.locationId !== undefined &&
    activity.state !== ActivityState.Unscheduled
  );
}

export function getSubLocations(locations?: Location[]): SubLocation[] {
  if (!locations) {
    return [];
  }

  return locations
    .filter((location) => location.subLocations)
    .map((location) => location.subLocations ?? [])
    .flat();
}

export function getLocationValue(
  locations: Location[],
  subLocations: SubLocation[],
  locationId: number | null | undefined,
  subLocationId: number | null | undefined
): string {
  if (!locationId) {
    return 'N/A';
  }

  const location = locations.find((location) => location.id === locationId);
  const subLocation = subLocations.find(
    (location) => location.id === subLocationId
  );

  if (location && location.name && subLocation) {
    const subLocationBelongsToLocation = !!location.subLocations?.find(
      (subLocation) => subLocation.id === subLocationId
    );
    return subLocationBelongsToLocation
      ? `${location.name}: ${subLocation.name}`
      : location.name;
  }

  if (location && location.name && !subLocation) {
    return location.name;
  }

  return 'N/A';
}
